import React, { useContext, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./routes";
import { Provider, useDispatch, useSelector } from "react-redux";
import { persistor, store } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import WebSocketClient from "./utils/WebSocketClient";
import { setMembers, UpdateRequest, UpdateBreakSocket } from "./store/slices/memberSlice";
import { getMembers } from "./services";
import { requestTypes, status } from "./utils/Helpers";
import { AppProvider, AppContext } from "./utils/AppContext";
import moment from "moment";
import _ from "lodash";
import { setUserInfo } from "./store/slices/UserSlice";


function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppProvider>
          <MainApp />
        </AppProvider>
      </PersistGate>
    </Provider>
  );
}

function MainApp() {
  const isAuth = useSelector((state) => state.user.isAuthenticated);
  const loggedInMember = useSelector((state) => state.user.userinfo);

  const theme = useSelector((state) => state.theme.mode);
  const dispatch = useDispatch();
  const { SetUpadateStatusData, setNewRequest, setInvoice, setAttendanceSocket, setBreakSocket } = useContext(AppContext);

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  const fetchMembers = async () => {
    try {
      console.log("Working");

      const response = await getMembers(0, 100);
      const allMembers = response?.data?.Result?.members;
      if (!_.isEmpty(allMembers)) {
        const filteredMembers = _.filter(allMembers, { Id: loggedInMember.Id })[0];
        console.log("All Members", filteredMembers, loggedInMember);

        dispatch(setUserInfo(filteredMembers));
        if (loggedInMember.MemberRole == "2") {
          dispatch(setMembers(allMembers));
        }
      }
    } catch (err) {
      console.error("Error fetching members:", err);
    }
  };


  useEffect(() => {
    if (isAuth) {
      fetchMembers();
    }
  }, [isAuth && loggedInMember.MemberRole]);

  const HandleMemberRequest = (data) => {
    if (loggedInMember.MemberRole == "2" && data.MemberId != loggedInMember.Id) {

      toast(
        <div>
          <h3 className="dark:text-gray-800 text-gray-800 mt-1 font-[550px]">Request Alert!</h3>
          <p className="dark:text-gray-800 text-gray-800 mt-1 text-[17px]">
            {data.MemberName} has requested {requestTypes[data.MemberRequest]}
          </p>
        </div>,
        {
          containerId: 'toasters',
          position: "top-right",
          icon: false,
          autoClose: 3000,
          className: "dark:bg-[#b2e3f5] bg-[#b2e3f5] font-medium dark:text-gray-800 text-gray-800",
          style: {
            borderBottom: "2px solid gray",
            padding: "2px 6px",
            fontSize: '1.4rem',
            minHeight: "60px",
            margin: "0px",
            fontweight: "500",
            letterspacing: "0.3px",
          },
          progressStyle: {
            backgroundColor: "blue",
          },
        }
      );

      setNewRequest(data)
    }
  }

  const HandleRequestStatus = (data) => {

    if (data.MemberId == loggedInMember.Id) {

      toast(
        <div>
          <p className="dark:text-gray-800 text-gray-800 mt-1"> Your {requestTypes[data.MemberRequest]} request has been {status[data.MemberStatus]}</p>
        </div>,
        {
          containerId: 'toasters',
          position: "top-right",
          icon: false,
          autoClose: 3000,
          className: "dark:bg-[rgb(193,236,193)] bg-green-800 font-medium dark:text-gray-800 text-gray-800",
          style: {
            borderBottom: "2px solid gray",
            padding: "2px 6px",
            fontSize: '1.4rem',
            minHeight: "60px",
            margin: "0px",
            fontsize: "22px",
            fontweight: "500",
            letterspacing: "0.3px",
          },
          progressStyle: {
            backgroundColor: "green",
          },
        }
      );
      dispatch(UpdateRequest({ Id: data.Id, Status: data.MemberStatus }));
      SetUpadateStatusData(data)
    }
  }

  const HandleStatusUpdate = (data) => {
    if (data.MemberId == loggedInMember.Id) {
      const lastMonth = moment().subtract(1, 'months').format('MMMM');
      const lastYear = moment().subtract(1, 'months').format('YYYY');
      toast(
        <div>
          <p className="dark:text-gray-800 text-gray-800 mt-1">{`The invoice for ${lastMonth}-${lastYear} has generated.`}</p>
        </div>,
        {
          containerId: 'toasters',
          position: "top-right",
          icon: false,
          autoClose: 3000,
          className: "dark:bg-[rgb(193,236,193)] bg-green-800 font-medium dark:text-gray-800 text-gray-800",
          style: {
            borderBottom: "2px solid gray",
            padding: "2px 6px",
            fontSize: '1.4rem',
            minHeight: "60px",
            margin: "0px",
            fontsize: "22px",
            fontweight: "500",
            letterspacing: "0.3px",
          },
          progressStyle: {
            backgroundColor: "green",
          },
        }
      );
      setInvoice(data)
    }
  }

  const HandleAttendance = (data) => {
    if (data.MemberId == loggedInMember.Id) {
      setAttendanceSocket(data)
    }

    if (loggedInMember.MemberRole == "2" && data.MemberId != loggedInMember.Id) {
      toast(
        <div>
          <h3 className="dark:text-gray-800 text-gray-800 mt-1 font-[550px]">{data.Title}</h3>
          <p className="dark:text-gray-800 text-gray-800 mt-1 text-[17px]">{data.Message}</p>
        </div>,
        {
          containerId: 'toasters',
          position: "top-right",
          icon: false,
          autoClose: 3000,
          className: "dark:bg-[#b2e3f5] bg-[#b2e3f5] font-medium dark:text-gray-800 text-gray-800",
          style: {
            borderBottom: "2px solid gray",
            padding: "2px 6px",
            fontSize: '1.4rem',
            minHeight: "60px",
            margin: "0px",
            fontsize: "22px",
            fontweight: "500",
            letterspacing: "0.3px",
          },
          progressStyle: {
            backgroundColor: "blue",
          },
        }
      );
    }
  }

  const HandleBreak = (data) => {
    if (data.MemberId == loggedInMember.Id) {
      setBreakSocket(data)
    }

    if (loggedInMember.MemberRole == "2") {
      dispatch(UpdateBreakSocket({ Id: data.MemberId, BreakType: data.BreakType, BreakReason: data.BreakReason }));
    }

  }

  const handleReceiveData = (payload) => {
    // console.log("Socket", payload)
    switch (payload?.Event) {
      case "MemberRequest":
        HandleMemberRequest(payload?.data)
        break;
      case "RequestStatus":
        HandleRequestStatus(payload?.data)
        break;
      case "RequestStatus":
        HandleRequestStatus(payload?.data)
        break;
      case "InvoiceStatusUpdate":
        HandleStatusUpdate(payload?.data)
        break;
      case "Attendance":
        HandleAttendance(payload?.data)
        break;
      case "Break":
        HandleBreak(payload?.data)
        break;


      default:
        break;
    }
  };


  return (
    <div className="App dark:bg-black">
      <AppRoutes />
      <WebSocketClient url={"wss://io.stakeriq.com/gentrick_staffing/a11wdsawe5f678901234567890abcdef"} onReceiveData={handleReceiveData} />
      <ToastContainer containerId="toasters" className="foo" style={{ width: "480px" }} />
      <ToastContainer />

    </div>
  );
}

export default App;
